module.exports = __webpack_public_path__ + "static/media/insta12.e4c45792.jpg";